module.exports = __webpack_public_path__ + "static/media/failure-boat.c15bfb3e.svg";